import React from 'react';
import './top-navigator.scss';

function TopNavigator({ text = '返回' }) {
  if (history.length <= 2) {
    return null;
  }

  const handleBtnTouchTap = () => {
    history.back();
  };

  return (
    <button
      title={text}
      className="top-navigator"
      onTouchTap={handleBtnTouchTap}
    />
  );
}

export default TopNavigator;



// WEBPACK FOOTER //
// ./src/component/common/top-navigator.jsx